import React from 'react';
import PropTypes from 'prop-types';
import { Link, HeadingText, BodyText } from '@paypalcorp/pp-react';
import { preventTabNabbing } from '../../../lib/helpers';

// Parser for the details footer
export const detailsFooterContentParser = (detailsContent = '') => {
  let buffData = {};
  try {
    buffData = JSON.parse(detailsContent);
  } catch (error) {
    buffData = null;
  }

  if (!buffData) {
    return buffData;
  }

  const linkItemValues = buffData;
  let linkItemValuesPair = [];
  if (linkItemValues.length > 0) {
    const splitTwoSections = Math.ceil(linkItemValues.length / 2);
    const linkItemSectionCenter = linkItemValues.slice(0, splitTwoSections);
    const linkItemSectionRight = linkItemValues.slice(
      splitTwoSections,
      linkItemValues.length
    );
    linkItemValuesPair = [linkItemSectionCenter, linkItemSectionRight];
  }
  return linkItemValuesPair;
};

export const LeftColumnSection = props => {
  const {
    questionsLabel,
    helpLabel,
    handleClickFPTI,
    subtitleLink,
    app
  } = props;
  const { context: { location: { domain } = {} } = {} } = app;
  return (
    <div className="details-sections">
      <div className="left-section">
        <HeadingText level={2}  className="question-label">{questionsLabel}</HeadingText>
        <div className="details-footer-links-style font-size-p">
          <BodyText
            onClick={e =>
              e.target.tagName === 'A' &&
              e.target.getAttribute('data-fptilinkname')
                ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
                : {}
            }
            dangerouslySetInnerHTML={{ __html: helpLabel }}
            role="presentation"
          ></BodyText>
          <Link
            rel={preventTabNabbing(subtitleLink.url, domain)}
            href={subtitleLink.url}
            onClick={() =>
              subtitleLink.fptiLinkName
                ? handleClickFPTI(subtitleLink.fptiLinkName)
                : {}
            }
          >
            {subtitleLink.text}
          </Link>
        </div>
      </div>
    </div>
  );
};

export const LinksColumnSection = props => {
  const { handleClickFPTI, linkItems, app } = props;
  const { context: { location: { domain } = {} } = {} } = app;

  return (
    <div className="details-sections details-sections-right">
      {linkItems.map(footerLink => {
        return (
          <div
            key={`footer-link-${footerLink.fptiLinkName}`}
            onClick={() =>
              footerLink.fptiLinkName
                ? handleClickFPTI(footerLink.fptiLinkName)
                : {}
            }
            role="presentation"
            className="details-sections-links-data"
          >
            <div
              className="lazyload footer-link-img"
              data-bg={footerLink.icon}
            />
            <BodyText className="font-size-p">
              <Link
                href={footerLink.url}
                rel={preventTabNabbing(footerLink.url, domain)}
              >
                {footerLink.text}
              </Link>
            </BodyText>
          </div>
        );
      })}
    </div>
  );
};

LeftColumnSection.propTypes = {
  handleClickFPTI: PropTypes.func,
  leftColumnData: PropTypes.object,
  questionsLabel: PropTypes.string,
  helpLabel: PropTypes.string,
  subtitleLink: PropTypes.string,
  app: PropTypes.object
};

LinksColumnSection.propTypes = {
  linkItems: PropTypes.array,
  handleClickFPTI: PropTypes.func,
  toolName: PropTypes.string,
  app: PropTypes.object
};

export default {
  detailsFooterContentParser,
  LinksColumnSection,
  LeftColumnSection
};
